import AddIcon from "../../../assets/svg/icono_agregar_blue.svg";
type BtnAddCompetenciesModelProps ={
    addCompetencie: ()=> void
    disabled: boolean
  }
const BtnAddCompetenciesCourse = ({addCompetencie, disabled}:BtnAddCompetenciesModelProps) => {
  return (
    <button
        id="addPrestacion"
       onClick={addCompetencie}  
       className={disabled === false ? "btnNuevoModeloEval" : "btnNuevoModeloEvalDisable"}
       disabled={disabled}
     >
       <div className="alineacionBotonModel">
          <img src={AddIcon} alt="Agregar Prestación" style={{height: '15.49px', width: '15.49px'}} />
        </div>
    </button> 
  )
}

export default BtnAddCompetenciesCourse